import { get } from 'lodash'
import type { FieldSpec } from '@wix/wix-data-schema-types'
import type { DynamicPageRouterData } from '../types'

const findPagelinkPattern = (
  field: FieldSpec,
  router: DynamicPageRouterData,
) => {
  const routerPatterns = Object.keys(get(router, ['config', 'patterns']) || {})

  return routerPatterns.find(
    routerPattern =>
      `/${router.prefix}${routerPattern}` ===
      get(field, ['calculator', 'config', 'pattern']),
  )
}

const findPageIdForPagelink = (
  field: FieldSpec,
  routers: DynamicPageRouterData[],
) =>
  routers.reduce<string | null | undefined>((foundPageId, router) => {
    if (foundPageId) {
      return foundPageId
    }

    const pattern = findPagelinkPattern(field, router)
    const pageRole = pattern && router.config.patterns[pattern].pageRole

    if (!pageRole) {
      return null
    }

    const page = router.pages.find(page => page.pageRoles.includes(pageRole))
    const pageId = get(page, ['pageRef', 'id'])
    return pageId === field.linkedRouterPage ? pageId : null
  }, null)

export const isPageLinkStale = (
  pageLink: FieldSpec,
  routers: DynamicPageRouterData[],
) => {
  const pageId = findPageIdForPagelink(pageLink, routers)
  return !pageId
}
